<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rQMfSl/tc-custom/9781035800872.jpg?1718184630701" alt="This image is the cover for the book Relatable Management Tips"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Relatable Management Tips
      </h1>
      <p class="bookDescription body article font2">
        <p>This book contains simple business management principles that the author wishes they had been told when they were embarking on their management career. These simple business management tips, idioms and sayings: could revolutionise and standardise corporate language; consolidate decades of management experience and leadership courses, to assist busy new managers; and will continue to be applicable to various situations in business and organizations, well into the future. The highly experienced, recognized and qualified author seeks to: save new managers from embarrassment and frustration; assist managers to be more productive; and equip managers with common sense, practical, business management principles, to guide their decision making and actions on a daily basis.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dave A. P. Smith
      </h2>
      
      <p class="authorDescription body article">(My eldest son told me to write “I’m a legend!”) This book has been written by a highly qualified and very experienced manager, who worked in various private customer service and public service roles, over several decades. Some of the staff managed by the author could be described as judgmental, wilful, authoritarian, stubborn, confident, assertive, entitled, para-legal, para-military or litigious. (We can only imagine how they would describe the author!) The author completed all of the high-level leadership courses offered by their well-established, public organisation. One course was an interstate senior management leadership development course, with international attendees. Another course matched the author with a rotary and business mentor. The author also mentored numerous people within the author’s workplaces. The author seeks to assist other managers, by providing “pearls of wisdom”, and sharing observations and lessons learnt from experience (generally the hard way!). The author wishes: to save managers from embarrassment and frustration; to assist managers to be more productive and avoid pitfalls; they had been able to read this book, before embarking on their management career (as that might have led to skyrocketing promotions!); and that all who read this book have fruitful management careers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?27db6aec